import React from 'react';
import { Modal, Button } from 'antd';

import './styles.scss';
import { CONTEXT_MAIN_HEADER_ITEM, CONTEXT_MENU_ITEM, isWindow, LAYER_ACTIONS } from '../../../utils';
import { forOwn, groupBy } from 'lodash';

const ShortcutKeysModal = ({ visible = false, onClose = () => {} }) => {
  const shortCutDecor = (text) =>
    text.split(' ').map((t, i) => (
      <span key={i} className={t !== '+' ? 'shortcut-detail' : 'plus-icon'}>
        {t}
      </span>
    ));
  const renderShortcutAction = () => {
    const batchSelect = {
      text: 'Batch Select',
      shortcut: `${isWindow() ? 'Shift' : '⇧'} + Click`,
    };
    let stList = [];
    forOwn(
      groupBy({ ...CONTEXT_MAIN_HEADER_ITEM, ...CONTEXT_MENU_ITEM }, (item) => item.ctrlKey),
      (value) => (stList = [...value, ...stList]),
    );
    stList = stList.filter((item) => item.ctrlKey !== null);
    stList.push(batchSelect);
    return stList.map((s, i) => (
      <div className="row" key={i}>
        <div className="action-name">{`${s.text}: `}</div>
        <div className="action-shortcut">{shortCutDecor(s.shortcut)}</div>
      </div>
    ));
  };
  const renderSettingAction = () =>
    LAYER_ACTIONS.map((l, i) => (
      <div className="row" key={i}>
        <div className="action-name">{`${l.title}: `}</div>
        <div className="action-shortcut">{shortCutDecor(l.shortcut)}</div>
      </div>
    ));
  return (
    <>
      <Modal
        width={600}
        destroyOnClose
        open={visible}
        title="Keyboard Shortcuts"
        onCancel={onClose}
        className=" "
        footer={[
          <Button key="back" type="default" onClick={onClose}>
            Close
          </Button>,
        ]}
      >
        <div className="mo__shortcut-keys-body">
          <div className="table-cell">
            <div className="header">Actions</div>
            <div className="content">{renderShortcutAction()}</div>
          </div>
          <div className="table-cell">
            <div className="header">Settings</div>
            <div className="content">{renderSettingAction()}</div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ShortcutKeysModal;
